import type { ReactNode } from 'react';
import { NetworkMapBackdrop } from './NetworkMapBackdrop';

const LEGEND: Array<[string, string]> = [
  ['OLT', 'var(--primary)'],
  ['ODC', 'var(--bg-surface)'],
  ['ODP', 'var(--primary)'],
  ['Pelanggan', 'var(--status-online)'],
];

/** Shell of the pages outside the app (login, AI agent consent, access denied): map backdrop + glass card column. */
export function AuthLayout({ children }: { children: ReactNode }) {
  return (
    <div className="fn-auth">
      <NetworkMapBackdrop />
      <div className="fn-auth__body">{children}</div>
      <div className="fn-auth__legend" aria-hidden>
        {LEGEND.map(([label, color]) => (
          <span key={label}>
            <i
              style={{
                background: color,
                boxShadow: label === 'ODC' ? '0 0 0 2px var(--primary) inset' : undefined,
                borderRadius: label === 'ODC' || label === 'OLT' ? 3 : undefined,
              }}
            />
            {label}
          </span>
        ))}
      </div>
      <div className="fn-auth__footer">© {new Date().getFullYear()} Speedmax · FTTH NMS v1.0</div>
    </div>
  );
}

/** Speedmax logo badge for "Masuk dengan Speedmax ID" buttons. */
export function SpeedmaxMark() {
  return (
    <span className="fn-sso-logo" aria-hidden>
      <img src="/logo-only.png" alt="" width={20} height={20} />
    </span>
  );
}
